var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
// import 'babel-polyfill'
import 'velocity-animate';
import { create } from 'jss';
import * as React from 'react';
import { includes } from 'lodash';
import jssExtend from 'jss-extend';
import WebFont from 'webfontloader';
import 'velocity-animate/velocity.ui';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ApolloLink } from 'apollo-link';
import * as Sentry from '@sentry/browser';
import { Router } from 'react-router-dom';
import { RestLink } from 'apollo-link-rest';
import { ApolloClient } from 'apollo-client';
import { ApolloProvider } from 'react-apollo';
import JssProvider from 'react-jss/lib/JssProvider';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import store from './store';
import history from './history';
import Theme from './theme/theme';
import Layout from './theme/layout';
import client from './apolloConfig';
import { mainApi, sentryDsn } from './config';
import RootLogin from './components/routes/root-login';
import NotificationWrapper from './NotificationWrapper';
import { routes } from './fuse-configs/fuseRoutesConfig';
import { checkIfDevelopmentStage } from 'src/utils/common';
import { GlobalDialogs } from './components/GlobalDialogs';
import Authorization from './theme/components/Authorization';
import MainToolbar from './components/layouts/Main/MainToolbar';
import SupportButton from 'src/components/reusable/SupportButton';
import WebsocketWrapper from 'src/theme/components/WebSocketWrapper';
import { setUserData, setUserProfile } from './auth/store/actions/user.actions';
import { setOrganizationData } from './auth/store/actions/organization.actions';
import { setTubeData, setBrandingColor } from './auth/store/actions/tube.actions';
import { getTube, getLanguageData, getEmbedData, setOrginalOrgId, getOrganization, getNotifications, initializeCognito, getUserPermissions, getOrganizationDomainFromOrgId, } from './auth/cognito/organizationApi';
import { setLanguageData } from './auth/store/actions/lang.actions';
import { setIsViewOnlyMode } from 'src/store/actions/ui.actions';
import PublicEmbedPage from 'src/components/routes/embed/PublicEmbedPage';
import { InMemoryCache } from 'apollo-cache-inmemory';
import 'react-table/react-table.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './styles/index.css';
WebFont.load({
    google: {
        families: ['Roboto:400,400i,500&display=swap'],
    },
});
var isDevStage = checkIfDevelopmentStage();
var mainApiUrl = mainApi(isDevStage);
var userEmail;
if (!isDevStage) {
    Sentry.init({ dsn: sentryDsn });
}
if (!localStorage.getItem('lang')) {
    localStorage.setItem('lang', 'en-us');
}
var data = localStorage.getItem('isViewOnlyMode');
if (!!data) {
    setIsViewOnlyMode()(store.dispatch);
}
var jss = create(__assign(__assign({}, jssPreset()), { plugins: __spreadArray(__spreadArray([], jssPreset().plugins), [jssExtend()]) }));
// @ts-ignore
jss.options.insertionPoint = document.getElementById('jss-insertion-point');
var generateClassName = createGenerateClassName();
var renderPublicEmbedCodePage = function (orgId, hasActiveSubscription, logo) {
    var apolloClient = new ApolloClient({
        link: ApolloLink.from([
            new RestLink({
                endpoints: {
                    query: mainApiUrl.query,
                    command: mainApiUrl.command,
                    users: mainApiUrl.user,
                },
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
        ]),
        cache: new InMemoryCache(),
    });
    ReactDOM.render(React.createElement(JssProvider, { jss: jss, generateClassName: generateClassName },
        React.createElement(Provider, { store: store },
            React.createElement(ApolloProvider, { client: apolloClient },
                React.createElement(Router, { history: history },
                    React.createElement(Theme, null,
                        React.createElement(PublicEmbedPage, { orgId: orgId, hasActiveSubscription: hasActiveSubscription, logo: logo })))))), document.getElementById('root'));
};
var isOrgPresent = true;
var start = function () { return __awaiter(void 0, void 0, void 0, function () {
    var matchOrgFromUrl, matchOrgFromUrlDev, isLoginPage, isEmbedCodePage, lastOrgId, orgId, isPrivateEmbedPage, org_1, embedData, e_1, isEmbedPage, org, userOrg, computedOrgData, collabOrgId, collaborationOrgDomain, cognitoUser, _a, tube, userPermissions, notificationsFeature, isNotificationsFeatureEnabled, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                matchOrgFromUrl = window.location.href.match(/([a-zA-Z0-9-_]*)\.trainingtube\.com/);
                matchOrgFromUrlDev = window.location.href.match(/([a-zA-Z0-9-_]*)\.dev\.trainingtube\.com/);
                isLoginPage = includes(window.location.href, 'login-lp');
                isEmbedCodePage = includes(window.location.href, '/sharing/');
                lastOrgId = localStorage.getItem('lastOrgId');
                orgId = null;
                if (isDevStage) {
                    if (matchOrgFromUrlDev) {
                        orgId = matchOrgFromUrlDev[1];
                    }
                    else {
                        // orgId = localStorage.getItem('forceOrgId') || 'uivvn-net-1'
                        orgId = localStorage.getItem('forceOrgId') || 'trainingtube';
                    }
                }
                else if (matchOrgFromUrl) {
                    orgId = matchOrgFromUrl[1];
                    if (lastOrgId &&
                        orgId !== lastOrgId &&
                        window.location.pathname !== '/login-lp' &&
                        window.location.pathname !== '/lp') {
                        return [2 /*return*/, (window.location.href =
                                'https://www.trainingtube.com/login?redirectTo=' + window.location.pathname + '&commingFrom=' + lastOrgId)];
                    }
                }
                if (!isEmbedCodePage) return [3 /*break*/, 6];
                isPrivateEmbedPage = false;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                return [4 /*yield*/, getOrganization(orgId, mainApiUrl.query, mainApiUrl.command, mainApiUrl.user, !isLoginPage && !isEmbedCodePage)];
            case 2:
                org_1 = _b.sent();
                setOrginalOrgId(org_1.id);
                return [4 /*yield*/, getEmbedData(orgId, window.location.href
                        .split('?')[0]
                        .split('/')
                        .pop())];
            case 3:
                embedData = _b.sent();
                if (!embedData.publicEmbed) {
                    isPrivateEmbedPage = true;
                }
                return [3 /*break*/, 5];
            case 4:
                e_1 = _b.sent();
                return [3 /*break*/, 5];
            case 5:
                if (!isPrivateEmbedPage) {
                    renderPublicEmbedCodePage(org_1.id, org_1.hasActiveSubscription, org_1.logo);
                    return [2 /*return*/];
                }
                _b.label = 6;
            case 6:
                isEmbedPage = history.location.pathname.startsWith('/sharing/embed') ||
                    history.location.pathname.startsWith('/sharing') ||
                    history.location.pathname.startsWith('/embed');
                if (!orgId) {
                    ReactDOM.render(React.createElement(JssProvider, { jss: jss, generateClassName: generateClassName },
                        React.createElement(Provider, { store: store },
                            React.createElement(Router, { history: history },
                                React.createElement(Theme, null,
                                    React.createElement(RootLogin, { apiUrl: mainApiUrl.query }))))), document.getElementById('root'));
                    return [2 /*return*/];
                }
                _b.label = 7;
            case 7:
                _b.trys.push([7, 14, 15, 16]);
                return [4 /*yield*/, getOrganization(orgId, mainApiUrl.query, mainApiUrl.command, mainApiUrl.user, !isLoginPage)];
            case 8:
                userOrg = _b.sent();
                collabOrgId = localStorage.getItem('collaborationOrgId');
                collaborationOrgDomain = void 0;
                if (!collabOrgId) return [3 /*break*/, 10];
                return [4 /*yield*/, getOrganizationDomainFromOrgId(collabOrgId, mainApiUrl.query)];
            case 9:
                collaborationOrgDomain = _b.sent();
                _b.label = 10;
            case 10:
                // TODO: Note this is not a orgId but a org domain, its just named a orgId, if you check the getOrganization function it expects a domain
                // Update this to orgDomain in a cleanup PR later on.
                orgId = collaborationOrgDomain || orgId;
                return [4 /*yield*/, getOrganization(orgId, mainApiUrl.query, mainApiUrl.command, mainApiUrl.user, !isLoginPage)];
            case 11:
                org = _b.sent();
                computedOrgData = __assign(__assign({}, org), { ssoUrl: userOrg.ssoUrl, userPoolClientId: userOrg.userPoolClientId, userPoolId: userOrg.userPoolId, cognitoIdentifier: userOrg.cognitoIdentifier, samlResponseUrl: userOrg.samlResponseUrl });
                setOrginalOrgId(org.id);
                setBrandingColor(org.color)(store.dispatch);
                if (!collabOrgId) {
                    localStorage.setItem('lastOrgId', orgId);
                }
                setOrganizationData(__assign(__assign({}, org), { ssoUrl: userOrg.ssoUrl, userPoolClientId: userOrg.userPoolClientId, userPoolId: userOrg.userPoolId, cognitoIdentifier: userOrg.cognitoIdentifier, samlResponseUrl: userOrg.samlResponseUrl, domain: orgId, featureFlags: [] }))(store.dispatch);
                return [4 /*yield*/, initializeCognito(userOrg)];
            case 12:
                cognitoUser = _b.sent();
                getLanguageData().then(function (res) {
                    // en-us is used from the local
                    if (res.data.lang !== 'en-us') {
                        setLanguageData(res.data.lang, res.data.data)(store.dispatch);
                    }
                });
                return [4 /*yield*/, Promise.all([getTube(), getUserPermissions()])];
            case 13:
                _a = _b.sent(), tube = _a[0], userPermissions = _a[1];
                setTubeData(tube)(store.dispatch);
                // If somehow the local storage is cleared for collaborgId. Add it and reload the page
                if (!!userPermissions.originalOrgId && userPermissions.orgId !== collabOrgId) {
                    localStorage.setItem('collaborationOrgId', userPermissions.orgId);
                    window.location.reload();
                }
                // Note: originalOrgId is returned from the API only when in colloboration mode. It means the source org of the user.
                // If the local storage still collabOrgId but the backend doesnot have it remove it from local storage and reload the page
                if (!userPermissions.originalOrgId && !!collabOrgId) {
                    localStorage.removeItem('collaborationOrgId');
                    window.location.reload();
                }
                setOrganizationData(__assign(__assign({}, computedOrgData), { featureFlags: userPermissions.featureFlags }))(store.dispatch);
                setUserData(__assign(__assign({ role: userPermissions.permissions.updateOrganization ? 'admin' : 'member', data: {
                        organization: computedOrgData,
                        displayName: cognitoUser.email,
                        photoUrl: 'assets/images/avatars/profile.jpg',
                        email: cognitoUser.email,
                    } }, userPermissions), { settings: __assign({}, userPermissions.settings), externalOrgsUserHasAccessTo: userPermissions.externalOrgsUserHasAccessTo }))(store.dispatch);
                setUserProfile(userPermissions.userData)(store.dispatch);
                userEmail = cognitoUser.email || userPermissions.email;
                notificationsFeature = userPermissions.featureFlags.find(function (ff) { return ff.featureId === 'notifications'; });
                isNotificationsFeatureEnabled = notificationsFeature.configuration == 'tube';
                if (isNotificationsFeatureEnabled) {
                    //  We dont want to await this
                    getNotifications({ isFirstFetch: true });
                }
                return [3 /*break*/, 16];
            case 14:
                err_1 = _b.sent();
                if (err_1 === 'no organization found' || err_1.message === 'Failed to fetch') {
                    // window.location.href =
                    // 'https://www.trainingtube.com/login?redirectTo='
                    isOrgPresent = false;
                }
                setUserData({
                    role: 'guest',
                    data: {
                        organization: computedOrgData,
                        displayName: '',
                        photoUrl: '',
                        email: '',
                    },
                })(store.dispatch);
                return [3 /*break*/, 16];
            case 15:
                ReactDOM.render(React.createElement(JssProvider, { jss: jss, generateClassName: generateClassName },
                    React.createElement(Provider, { store: store },
                        React.createElement(ApolloProvider, { client: client(orgId, computedOrgData ? computedOrgData.ssoUrl : null) },
                            React.createElement(NotificationWrapper, null),
                            React.createElement(Router, { history: history },
                                React.createElement(Authorization, { isOrgPresent: isOrgPresent, routes: routes },
                                    React.createElement(WebsocketWrapper, { email: userEmail }),
                                    React.createElement(Theme, null,
                                        !isEmbedPage && React.createElement(SupportButton, null),
                                        React.createElement(Layout, { isDevStage: isDevStage, routes: routes, toolbar: !mainApiUrl.maintenance && (React.createElement(MainToolbar, { routes: routes, history: history, isDevStage: isDevStage })) })),
                                    React.createElement(GlobalDialogs, null)))))), document.getElementById('root'));
                return [7 /*endfinally*/];
            case 16: return [2 /*return*/];
        }
    });
}); };
start().catch(function (err) { return console.log(err); });



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 841
// module chunks = 81